import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../config/redux/types';
import { setFilterSet } from '../../../features/request/actions';
import SearchFilter from '../components/SearchFilter';
import filterData from '../static/searchFilter';

export default function SearchFilterContainer(): JSX.Element {
  const dispatch = useDispatch();
  const filterSet = useSelector((state: RootState) => state.request.filterSet);

  return (
    <SearchFilter
      searchFilters={filterData()}
      filterSet={filterSet}
      onChange={(filterSetChange): unknown => dispatch(setFilterSet(filterSetChange))}
    />
  );
}
